const alertActionType = {
    SET_ALERT: "SET_ALERT",
    SET_UUID_FOR_ALERT:  "SET_UUID_FOR_ALERT",
    SET_ENDPOINT_FOR_ALERT: "SET_ENDPOINT_FOR_ALERT",
    RESET_ALERT: "RESET_ALERT"
}

export default alertActionType;
